import { jsx as _jsx } from "react/jsx-runtime";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Alert, Space } from "antd";
import { spacing } from "../../../../styles/spacing.js";
/**
 * Displays a validation list of given results.
 */ const ReleaseValidations = (props)=>{
    const { releaseValidationResults } = props;
    return /*#__PURE__*/ _jsx(Space, {
        direction: "vertical",
        style: {
            width: "100%",
            paddingLeft: spacing.layout.content.padding
        },
        children: releaseValidationResults.map((result, index)=>{
            return /*#__PURE__*/ _jsx(Alert, {
                icon: /*#__PURE__*/ _jsx(ExclamationCircleOutlined, {
                    style: {
                        color: "red",
                        textAlign: "center"
                    }
                }),
                ...result
            }, index);
        })
    });
};
export { ReleaseValidations };
